import * as cx from 'classnames';
import { Picker } from 'mk/forms/Picker';
import { Context } from 'mk/interfaces';
import Sticker, { StickerSize } from 'mk2/components/Sticker';
import * as React from 'react';
import { findDOMNode } from 'react-dom';

const STICKER_SETS = {
    PONNY: [1, 2, 3, 12, 15, 11, 14, 13, 10],
    CUTIE: [4, 5, 6, 16, 17, 18, 19, 20, 21],
    BUNNY: [7, 8, 9, 22, 26, 24, 25, 27, 23],
};

interface OwnProps {
    className?: string;
    context: Context;
    name: string;
    initial?: number;

    onChange(id: number);
}

interface State {
    opened: boolean;
    value: number;
}

export default class StickerSelect extends React.Component<OwnProps, State> {

    public static defaultProps = {
        initial: null,
    };

    public static isFormField() {
        return true;
    }

    public validate() {
        return [this.state.value, null];
    }

    public clear() {
        if (!this.state.value) {
            return;
        }

        this.setState({
            value: this.props.initial,
        });

        // Notify parent about change
        if (this.props.onChange) {
            this.props.onChange(this.props.initial);
        }
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: false,
            value: props.initial,
        };
    }

    public render() {
        const {opened} = this.state;
        return (
            <div className={cx('sticker-select', this.props.className)}>
                <div className="g-form-sticker-select form-action-button">
                    <Picker
                        sets={STICKER_SETS}
                        getItem={this.getPickerItem}
                        onSelect={this.onSelect}
                        opened={opened}
                    />
                    <div className={cx('sticker', 'trigger', opened ? 'selected' : '')} onClick={this.toggle}>
                        <Sticker
                            id={this.state.value || 1}
                            size={StickerSize.Icon}
                            lazy={false}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private documentClickHandler = (e) => {
        const domNode = findDOMNode(this);
        if (domNode instanceof Element && !domNode.contains(e.target)) {
            this.close();
        }
    };

    private open = () => {
        window.addEventListener('click', this.documentClickHandler);
        this.setState({opened: true});
    };

    private close = () => {
        window.removeEventListener('click', this.documentClickHandler);
        this.setState({opened: false});
    };

    private toggle = () => {
        this.state.opened ? this.close() : this.open();
    };

    private onSelect = (id) => {
        this.setState({value: id});
        this.close();
        if (this.props.onChange) {
            this.props.onChange(id);
        }
    };

    private getPickerItem = (id) => {
        return (
            <div className="sticker">
                <Sticker
                    id={id}
                    size={StickerSize.Icon}
                />
            </div>
        );
    };
}
